import { API_CUSTOM_HEADERS } from '@endion/types';

export function saveContactKeyToLocalStorage(contactKey: string) {
  localStorage.setItem(API_CUSTOM_HEADERS.X_CHAT_CONTACT_KEY, contactKey);
}

export function getContactKeyFromLocalStorage() {
  return localStorage.getItem(API_CUSTOM_HEADERS.X_CHAT_CONTACT_KEY);
}

export const STORAGE_KEY_CHAT_CONVERSATION_KEY = 'endion_chat_conversation_key' as const;

export function saveConversationKeyInLocalStorage(conversationKey: string) {
  localStorage.setItem(STORAGE_KEY_CHAT_CONVERSATION_KEY, conversationKey);
}

export function getConversationKeyFromLocalStorage() {
  return localStorage.getItem(STORAGE_KEY_CHAT_CONVERSATION_KEY);
}

export function clearConversationKeyFromBrowserStorage() {
  localStorage.removeItem(STORAGE_KEY_CHAT_CONVERSATION_KEY);
}
